import { render, staticRenderFns } from "./ToolBar.vue?vue&type=template&id=63b317ae&scoped=true"
var script = {}
import style0 from "./ToolBar.vue?vue&type=style&index=0&id=63b317ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b317ae",
  null
  
)

export default component.exports